import type { QueryClient } from '@tanstack/react-query';
import { commonQueryKeys } from '@/common/queryKeys/common';

const VISIBLE_TABLE_PROVIDERS = Object.values(commonQueryKeys.itemsTable);

// Matches a provider exactly or a sub-namespace of it (e.g. the
// `itemsTable.visibleItems.extras` cache for referenced item-ref cells).
const isVisibleTableProvider = (provider: string): boolean =>
  VISIBLE_TABLE_PROVIDERS.some((name) => provider === name || provider.startsWith(`${name}.`));

// removeQueries, not invalidateQueries: these caches use staleTime: Infinity and
// fetchers that skip already-cached ids, so a refetch returns the stale values —
// the rows must be dropped to force a refetch of fresh content.
export const removeVisibleTableCaches = (queryClient: QueryClient): void => {
  queryClient.removeQueries({
    predicate: (query) => {
      const provider = query.queryKey[0];
      return typeof provider === 'string' && isVisibleTableProvider(provider);
    },
  });
};
